import { Box, styled } from "@mui/material";

const ColorCircle = styled(Box)({
  width: 24,
  height: 24,
  borderRadius: "50%",
});

export default ColorCircle;
